export const BayEndpoints = {
  LIST: '/api/admin/logistics/bays',
  GET: '/api/admin/logistics/bays/:id',
  CREATE: '/api/admin/logistics/bays',
  UPDATE: '/api/admin/logistics/bays/:id',
};
